import * as React from 'react';
import Stack, { StackProps } from '@mui/material/Stack';

import { FormHeader, FormHeaderProps } from './FormHeader';
import { FormBody, FormBodyProps } from './FormBody';
import { FormFooter, FormFooterProps } from './FormFooter';

interface FormProps extends StackProps {
  children: React.ReactNode;
}

const Form = (props: Readonly<FormProps>) => {
  const { children, ...stackProps } = props;

  return (
    <Stack position="relative" height="100%" justifyContent="space-between" {...stackProps}>
      {children}
    </Stack>
  );
};

Form.Header = (props: FormHeaderProps) => <FormHeader {...props} />;
Form.Body = (props: FormBodyProps) => <FormBody {...props} />;
Form.Footer = (props: FormFooterProps) => <FormFooter {...props} />;

export { Form };
